import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { Typography, Button, Autocomplete, TextField, Grid } from '@mui/material';
import { Icon, InputWithIcon, CONSTANTS, BackdropLoader, toast } from '@livable/saas-react-components';
import useAddBillingTemplateModalFormStyles from './styles';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { ALLOCATION_METHOD, BILL_FREQUENCY, BILL_FREQUENCY_NAME, VACANT_UNIT_ALLOCATIONS, VACANT_UNIT_USAGE } from 'src/constants/utilities';
import BillFrequencyModal from '../../BillFrequencyModal';
import { isValueNumber } from 'src/utils/typeValidators';
import AllocationMethodModal from '../../AllocationMethodModal';
import VacantUnitBills from '../../VacantUnitBills';
import CADModal from '../../CADModal';
import ListItem from '../../UtilityAccordion/listItem';
import { UtilitiesAutocomplete } from './UtilitiesAutocomplete';
import { getRequiredTextMessage } from 'src/utils/formValidation';
import { BillingAutomationSetup } from '../BullingAutomationSetup';
import GLModal from '../../GLModal';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import { UtilityCredentialSlot } from 'src/components/property/UtilityPortalCredentials/UtilityCredentialSlot';
import { EMPTY_PENDING_CREDENTIAL } from 'src/components/property/UtilityPortalCredentials/PendingCredentialFields';
import { savePendingCredential } from 'src/components/property/UtilityPortalCredentials/savePendingCredential';
import { isScraperSupported } from 'src/components/property/UtilityPortalCredentials/credentialStatus';
import { currentCompanyId } from 'src/components/property/UtilityPortalCredentials/currentCompanyId';
export const AddBillingTemplateModalForm = observer(_ref => {
  var _existingPropertyProv, _propertyUtility$util, _propertyUtility$vaca, _singleElementOfArray2, _propertyUtility$util2;
  let propertyId = _ref.propertyId,
    propertyUtility = _ref.propertyUtility,
    handleModalClose = _ref.handleModalClose,
    existingPropertyProviders = _ref.existingPropertyProviders,
    isEditBillingTemplate = _ref.isEditBillingTemplate,
    callbackTrigger = _ref.callbackTrigger,
    currentBuildingId = _ref.currentBuildingId;
  const classes = useAddBillingTemplateModalFormStyles();
  const modalFooterClasses = useModalFooterStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    customGlAccountId = _useState2[0],
    setCustomGlAccountId = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    customPayableGlAccountId = _useState4[0],
    setCustomPayableGlAccountId = _useState4[1];
  const _useState5 = useState(existingPropertyProviders.find(provider => {
      var _propertyUtility$prov;
      return provider.id === (propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$prov = propertyUtility.provider) === null || _propertyUtility$prov === void 0 ? void 0 : _propertyUtility$prov.utilityProviderId);
    }) || {}),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedProviderInfo = _useState6[0],
    setSelectedProviderInfo = _useState6[1];
  const _useState7 = useState(((_existingPropertyProv = existingPropertyProviders.find(provider => {
      var _propertyUtility$prov2;
      return provider.id === (propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$prov2 = propertyUtility.provider) === null || _propertyUtility$prov2 === void 0 ? void 0 : _propertyUtility$prov2.utilityProviderId);
    })) === null || _existingPropertyProv === void 0 ? void 0 : _existingPropertyProv.utilities.map(ut => {
      return _objectSpread(_objectSpread({}, ut), {}, {
        label: (ut === null || ut === void 0 ? void 0 : ut.utilityTypeName) || (ut === null || ut === void 0 ? void 0 : ut.name),
        id: ut.utilityTypeId || ut.id,
        key: ut.utilityTypeId || ut.id
      });
    })) || []),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedProviderUtilities = _useState8[0],
    setSelectedProviderUtilities = _useState8[1];
  const _useState9 = useState((propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$util = propertyUtility.utilityTypes) === null || _propertyUtility$util === void 0 ? void 0 : _propertyUtility$util.map(ut => {
      return _objectSpread(_objectSpread({}, ut), {}, {
        label: ut.utilityTypeName,
        id: ut.utilityTypeId || ut.id,
        key: "key_".concat(ut.utilityTypeId || ut.id)
      });
    })) || []),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedUtilities = _useState0[0],
    setSelectedUtilities = _useState0[1];

  // Utility portal credentials. Staff-only: the endpoints behind this are Permissions.AdminOrHigher,
  // so a customer rendering it anyway would only collect 403s. Hidden rather than disabled because
  // there is nothing useful a customer could do with it yet.
  const isLivableStaff = store.account.userProfile.isUserLivableStaff;
  const pendingCredentialRef = useRef(_objectSpread({}, EMPTY_PENDING_CREDENTIAL));
  const _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    utilityCredential = _useState10[0],
    setUtilityCredential = _useState10[1];
  const _useState11 = useState(selectedProviderInfo.isCustom || false),
    _useState12 = _slicedToArray(_useState11, 2),
    isCustomProviderMode = _useState12[0],
    setIsCustomProviderMode = _useState12[1];
  const _useState13 = useState(selectedProviderInfo.name || ''),
    _useState14 = _slicedToArray(_useState13, 2),
    customProviderName = _useState14[0],
    setCustomProviderName = _useState14[1];
  const _useState15 = useState(selectedProviderInfo.website || ''),
    _useState16 = _slicedToArray(_useState15, 2),
    customProviderWebsite = _useState16[0],
    setCustomProviderWebsite = _useState16[1];

  // companyId is the selected company in local storage - the same source store.company and
  // store.admin read. An impersonating admin therefore writes the credential against the company
  // they are acting as, which is the intent.
  const companyId = currentCompanyId();
  const isScraperSupportedProvider = isScraperSupported(selectedProviderInfo);
  const loadCredential = async () => {
    if (!isLivableStaff || !(propertyUtility !== null && propertyUtility !== void 0 && propertyUtility.propertyUtilityId)) return;
    try {
      const resp = await store.admin.getUtilityCredentialsAsync.run({
        companyId,
        propertyId,
        propertyUtilityId: propertyUtility.propertyUtilityId
      });
      const rows = (resp === null || resp === void 0 ? void 0 : resp.response) || resp;
      setUtilityCredential(Array.isArray(rows) ? rows[0] || null : null);
    } catch (error) {
      // Never block the billing template on the credential lookup - the template is the primary
      // job of this modal and must stay editable if the credential service is unavailable.
      setUtilityCredential(null);
    }
  };
  useEffect(() => {
    loadCredential();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLivableStaff, propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId]);
  const saveCredentialAfterUtilityExists = async () => {
    var _singleElementOfArray;
    if (!isLivableStaff) return;
    // Snapshot the secret and drop it from the form before the async work.
    const pending = pendingCredentialRef.current;
    pendingCredentialRef.current = _objectSpread({}, EMPTY_PENDING_CREDENTIAL);
    await savePendingCredential({
      store,
      pending,
      companyId,
      propertyId,
      utilityProviderId: selectedProviderInfo === null || selectedProviderInfo === void 0 ? void 0 : selectedProviderInfo.id,
      utilityTypeId: (_singleElementOfArray = singleElementOfArray(selectedUtilities)) === null || _singleElementOfArray === void 0 ? void 0 : _singleElementOfArray.id
    });
  };
  const _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    searchResultItems = _useState18[0],
    setSearchResultItems = _useState18[1];
  let searchUtilityProvidersHandler;
  const searchUtilityProviders = async (event, value) => {
    if (value && value.length > 0) {
      if (searchUtilityProvidersHandler) {
        setSearchResultItems([]);
        clearTimeout(searchUtilityProvidersHandler);
      }
      searchUtilityProvidersHandler = setTimeout(() => store.utilityProviders.searchUtilityProvidersAsync.run(value).then(resp => {
        setSearchResultItems([{
          id: 'createCustomProviderId',
          key: 'createCustomProviderKey',
          label: value + ' (add new provider)',
          inputName: value
        }, ...resp.response.map(item => {
          return _objectSpread(_objectSpread({}, item), {}, {
            id: item.key,
            key: item.key,
            label: item.value
          });
        })]);
      }), 350);
    } else {
      if (searchUtilityProvidersHandler) clearTimeout(searchUtilityProvidersHandler);
    }
    setSearchResultItems([{
      id: 'createCustomProviderId',
      key: 'createCustomProviderKey',
      label: value + ' (add new provider)',
      inputName: value
    }]);
  };
  const resetNewProviderConfigurator = async () => {
    const resp = await store.utilityProviders.getAllUtilityTypesAsync.run({});
    const utilities = resp.response.map(ut => {
      return _objectSpread(_objectSpread({}, ut), {}, {
        id: ut.utilityTypeId || ut.id,
        utilityTypeId: ut.utilityTypeId || ut.id,
        utilityId: ut.utilityTypeId,
        name: ut.utilityTypeName,
        label: ut.utilityTypeName
      });
    });
    setSelectedProviderUtilities(utilities);
  };
  const configureUtilityProvider = async (event, value) => {
    clearTimeout(searchUtilityProvidersHandler);
    setSearchResultItems([]);
    if (value && (value === null || value === void 0 ? void 0 : value.id) === 'createCustomProviderId') {
      // toggle custom provider create
      setIsCustomProviderMode(true);
      setCustomProviderName(value.inputName);
      await resetNewProviderConfigurator();
      return;
    }
    if (value && (value !== null && value !== void 0 && value.id || value !== null && value !== void 0 && value.utilityProviderId)) {
      await Promise.all([store.utilityProviders.getUtilityProvidersListDataAsync.run({
        utilityProviderIds: [value.id || value.utilityProviderId]
      }).then(async resp => {
        if (resp && resp.isSuccessful) {
          setSelectedUtilities([]);
          store.addNewProperty.utilitiesSetupV2.setNewUtilityConfiguration(singleElementOfArray(resp.response));
          setSelectedProviderInfo(_objectSpread({}, singleElementOfArray(resp.response)));
          setSelectedProviderUtilities(singleElementOfArray(resp.response).utilities.map(ut => {
            return _objectSpread(_objectSpread({}, ut), {}, {
              label: ut.name,
              id: ut.utilityTypeId
            });
          }));
        }
      })]);
    }
  };
  const utility = {
    billFrequencyType: BILL_FREQUENCY[propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.billFrequencyType] || BILL_FREQUENCY.Monthly,
    allocationMethod: ALLOCATION_METHOD[propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.allocationMethod] || ALLOCATION_METHOD.ByOccupancy,
    vacantUnitAllocation: VACANT_UNIT_ALLOCATIONS.DivideAmongOccupied,
    vacantUnitUsage: VACANT_UNIT_USAGE[propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.vacantUnitUsage] || VACANT_UNIT_USAGE.NoUsage,
    vacantUnitUsageLimit: (_propertyUtility$vaca = propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.vacantUnitUsageLimit) !== null && _propertyUtility$vaca !== void 0 ? _propertyUtility$vaca : null,
    utilityCAD: (propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.commonAreaDeduction) || 5,
    isDefaultCAD: null
  };
  const propertySqFootageExternal = undefined;
  const customMode = false;
  const isEdit = true;
  const _useState19 = useState(utility.billFrequencyType),
    _useState20 = _slicedToArray(_useState19, 2),
    utilityBillFrequency = _useState20[0],
    setUtilityBillFrequency = _useState20[1];
  const _useState21 = useState(utility.allocationMethod),
    _useState22 = _slicedToArray(_useState21, 2),
    utilityAllocationMethod = _useState22[0],
    setUtilityAllocationMethod = _useState22[1];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState23 = useState(utility.vacantUnitAllocation),
    _useState24 = _slicedToArray(_useState23, 2),
    vacantUnitBills = _useState24[0],
    setVacantUnitBills = _useState24[1];
  const _useState25 = useState(utility.vacantUnitUsage),
    _useState26 = _slicedToArray(_useState25, 2),
    vacantUnitUsage = _useState26[0],
    setVacantUnitUsage = _useState26[1];
  const _useState27 = useState((utility === null || utility === void 0 ? void 0 : utility.vacantUnitUsageLimit) !== null ? Number.parseInt((utility.vacantUnitUsageLimit * 100).toFixed(0)) : null),
    _useState28 = _slicedToArray(_useState27, 2),
    vacantUnitUsageLimit = _useState28[0],
    setVacantUnitUsageLimit = _useState28[1];
  const _useState29 = useState(utility.utilityCAD || 5),
    _useState30 = _slicedToArray(_useState29, 2),
    utilityCad = _useState30[0],
    setUtilityCad = _useState30[1];
  const _useState31 = useState(propertySqFootageExternal || store.addNewProperty.utilitiesSetupV2.getPropertySqFootage),
    _useState32 = _slicedToArray(_useState31, 2),
    buildingSquareFootageLocal = _useState32[0],
    setBuildingSquareFootageLocal = _useState32[1];
  const getUtility = () => {
    return {
      billFrequencyType: utilityBillFrequency || BILL_FREQUENCY.Monthly,
      allocationMethod: utilityAllocationMethod || ALLOCATION_METHOD.ByOccupancy,
      vacantUnitAllocation: VACANT_UNIT_ALLOCATIONS.DivideAmongOccupied,
      vacantUnitUsage: vacantUnitUsage || VACANT_UNIT_USAGE.NoUsage,
      vacantUnitUsageLimit: vacantUnitUsageLimit || 10,
      utilityCAD: utilityCad || 5,
      isDefaultCAD: null,
      utilityTypeName: selectedUtilities.map(i => i.utilityTypeName).join('/')
    };
  };
  const genericSaveAndCloseHandler = values => {
    values.forEach(valueG => {
      valueG.values.forEach(_ref2 => {
        let key = _ref2.key,
          value = _ref2.value;
        if (key === 'billFrequencyType') {
          setUtilityBillFrequency(value);
        }
        if (key === 'allocationMethod') {
          setUtilityAllocationMethod(value);
        }
        if (key === 'vacantUnitUsage') {
          setVacantUnitUsage(value);
        }
        if (key === 'vacantUnitUsageLimit') {
          setVacantUnitUsageLimit(value);
        }
        if (key === 'utilityCAD') {
          setUtilityCad(value);
        }
      });
    });
  };
  const updateParentBuildingSquareFootageLocal = async value => {
    await store.properties.updatePropertyAsync.run({
      updateStore: true,
      propertyId,
      buildings: [{
        buildingId: currentBuildingId,
        buildingSquare: Number(value) !== Number(store.addNewProperty.utilitiesSetupV2.sqFootage) && isValueNumber(value) ? Number(value) : Number(store.addNewProperty.utilitiesSetupV2.sqFootage)
      }]
    });
    store.addNewProperty.utilitiesSetupV2.changeSqFootage(value);
    setBuildingSquareFootageLocal(value);
  };
  const GetBillingSettingsList = () => {
    const list = [{
      title: t('add_new_property_flow.auto_billing'),
      id: "UtilityAccordion_auto_billing_id",
      key: "UtilityAccordion_auto_billing_key",
      value: 'inactive',
      iconType: 'paper-dollar',
      isActive: true,
      action: /*#__PURE__*/React.createElement(BillingAutomationSetup, {
        customTrigger: /*#__PURE__*/React.createElement(Button, {
          variant: "actionButton",
          size: "small",
          'custom-attribute': '191-add-edit-billing-template-modal'
        }, t('add_new_property_flow.begin_activation')),
        isEdit: true
      })
    }, {
      title: t('add_new_property_flow.bill_frequency'),
      id: "UtilityAccordion_bill_frequency_id",
      key: "UtilityAccordion_bill_frequency_key",
      value: BILL_FREQUENCY_NAME[getUtility().billFrequencyType] || BILL_FREQUENCY_NAME.Monthly,
      isActive: BILL_FREQUENCY_NAME.Monthly !== BILL_FREQUENCY_NAME[getUtility().billFrequencyType] || true,
      isDefault: BILL_FREQUENCY_NAME.Monthly === BILL_FREQUENCY_NAME[getUtility().billFrequencyType],
      action: /*#__PURE__*/React.createElement(BillFrequencyModal, {
        utilityBillFrequancy: utilityBillFrequency,
        setUtilityBillFrequency: setUtilityBillFrequency,
        utility: getUtility(),
        onSaveAndClose: genericSaveAndCloseHandler,
        isEdit: isEdit,
        customMode: customMode
      })
    }, {
      title: t('add_new_property_flow.allocation_method'),
      id: "UtilityAccordion_allocation_method_id",
      key: "UtilityAccordion_allocation_method_key",
      value: CONSTANTS.ALLOCATION_METHODS[getUtility().allocationMethod] || !!getUtility().defaultAllocationMethod && CONSTANTS.ALLOCATION_METHODS[getUtility().defaultAllocationMethod] || t('general.occupancy'),
      isDefault: getUtility().defaultAllocationMethod === null || getUtility().defaultAllocationMethod === getUtility().allocationMethod,
      isActive: getUtility().defaultAllocationMethod !== null && getUtility().defaultAllocationMethod !== getUtility().allocationMethod,
      isError: (ALLOCATION_METHOD.BySquareFootage === getUtility().allocationMethod || ALLOCATION_METHOD.By50Occupancy50SquareFootage === getUtility().allocationMethod) && (buildingSquareFootageLocal ? !isValueNumber(buildingSquareFootageLocal) || isValueNumber(buildingSquareFootageLocal) && Number(buildingSquareFootageLocal) === 0 : !isValueNumber(propertySqFootageExternal) || isValueNumber(propertySqFootageExternal) && Number(propertySqFootageExternal) === 0),
      action: /*#__PURE__*/React.createElement(AllocationMethodModal, {
        setUtilityAllocationMethod: setUtilityAllocationMethod,
        utility: getUtility(),
        onSaveAndClose: genericSaveAndCloseHandler,
        isEdit: isEdit,
        customMode: customMode,
        setParentBuildingSquareFootageLocal: updateParentBuildingSquareFootageLocal,
        propertySqFootage: buildingSquareFootageLocal || propertySqFootageExternal || store.addNewProperty.utilitiesSetupV2.getPropertySqFootage
      })
    }, {
      title: t('add_new_property_flow.handling_vacant_unit'),
      id: "UtilityAccordion_handling_vacant_unit_id",
      key: "UtilityAccordion_handling_vacant_unit_key",
      value: getUtility().vacantUnitUsage === VACANT_UNIT_USAGE.NoUsage && t('add_new_property_flow.no_usage') || getUtility().vacantUnitUsage === VACANT_UNIT_USAGE.NormalUsage && t('add_new_property_flow.full_usage') || t('add_new_property_flow.unit_usage_limited_usage'),
      isDefault: getUtility().defaultVacantUnitUsage === null || getUtility().defaultVacantUnitUsage === getUtility().vacantUnitUsage,
      isActive: getUtility().defaultVacantUnitUsage !== null && getUtility().defaultVacantUnitAllocation !== getUtility().vacantUnitAllocation,
      action: /*#__PURE__*/React.createElement(VacantUnitBills, {
        setVacantUnitBills: setVacantUnitBills,
        setVacantUnitUsage: setVacantUnitUsage,
        utility: getUtility(),
        onSaveAndClose: genericSaveAndCloseHandler,
        isEdit: isEdit,
        customMode: customMode
      })
    }, {
      title: t('add_new_property_flow.common_area_deduction'),
      id: "UtilityAccordion_common_area_deduction_id",
      key: "UtilityAccordion_common_area_deduction_key",
      // isDefault: isUtilityCadDefault(getUtility().isDefaultCAD, getUtility().utilityCAD),
      isDefault: false,
      // isActive: !isUtilityCadDefault(getUtility().isDefaultCAD, getUtility().utilityCAD),
      isActive: true,
      value: utilityCad + '%',
      // isError: true, // NOTE: TBD if needed
      customMode: customMode,
      action: /*#__PURE__*/React.createElement(CADModal, {
        setUtilityCad: setUtilityCad,
        utility: getUtility(),
        onSaveAndClose: genericSaveAndCloseHandler,
        isEdit: isEdit || true,
        customMode: customMode
      })
    }];
    if (store.company.companyFeatureStore.isAppfolio) {
      var _customGl, _customGl2, _customGl3;
      let customGl = undefined;
      const defaultGl = store.credentials.glAccounts.find(i => i.externalId === store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId);
      const pUtility = store.credentials.utilitiesGlSettings.find(i => i.utilityId === utility.utilityId);
      if (customGlAccountId) {
        customGl = store.credentials.glAccounts.find(i => i.externalId === customGlAccountId);
      } else if (pUtility && pUtility !== null && pUtility !== void 0 && pUtility.glAccountExternalId) {
        customGl = store.credentials.glAccounts.find(i => i.externalId === pUtility.glAccountExternalId);
      }
      list.push({
        title: t('Resident Charges GL Account (Income)'),
        id: "UtilityAccordion_gl_id",
        key: "UtilityAccordion_gl_key",
        isDefault: !customGl || (defaultGl === null || defaultGl === void 0 ? void 0 : defaultGl.externalId) === ((_customGl = customGl) === null || _customGl === void 0 ? void 0 : _customGl.externalId),
        isActive: true,
        value: customGl && (_customGl2 = customGl) !== null && _customGl2 !== void 0 && _customGl2.name ? (_customGl3 = customGl) === null || _customGl3 === void 0 ? void 0 : _customGl3.name : defaultGl === null || defaultGl === void 0 ? void 0 : defaultGl.name,
        customMode: customMode,
        action: /*#__PURE__*/React.createElement(GLModal, {
          utility: getUtility(),
          onSaveAndCloseCustom: data => {
            setCustomGlAccountId(data);
          },
          isEdit: isEdit,
          customMode: customMode
        })
      });
      if (store.account.featureFlagsStore.getIsGlCodesEnabled) {
        var _customPayableGl, _customPayableGl2, _customPayableGl3;
        let customPayableGl = undefined;
        const defaultPayableGl = store.credentials.glAccounts.find(i => i.externalId === store.addNewProperty.utilitiesSetupV2.accountsPayableGlAccountExternalId);
        if (customPayableGlAccountId) {
          customPayableGl = store.credentials.glAccounts.find(i => i.externalId === customPayableGlAccountId);
        } else if (pUtility && pUtility !== null && pUtility !== void 0 && pUtility.accountsPayableGlAccountExternalId) {
          customPayableGl = store.credentials.glAccounts.find(i => i.externalId === pUtility.accountsPayableGlAccountExternalId);
        }
        list.push({
          title: t('Accounts Payable GL Account (Expense)'),
          id: "UtilityAccordion_payable_gl_id",
          key: "UtilityAccordion_payable_gl_key",
          isDefault: !customPayableGl || (defaultPayableGl === null || defaultPayableGl === void 0 ? void 0 : defaultPayableGl.externalId) === ((_customPayableGl = customPayableGl) === null || _customPayableGl === void 0 ? void 0 : _customPayableGl.externalId),
          isActive: true,
          value: customPayableGl && (_customPayableGl2 = customPayableGl) !== null && _customPayableGl2 !== void 0 && _customPayableGl2.name ? (_customPayableGl3 = customPayableGl) === null || _customPayableGl3 === void 0 ? void 0 : _customPayableGl3.name : defaultPayableGl === null || defaultPayableGl === void 0 ? void 0 : defaultPayableGl.name,
          customMode: customMode,
          action: /*#__PURE__*/React.createElement(GLModal, {
            isPayable: true,
            utility: getUtility(),
            onSaveAndCloseCustom: data => {
              setCustomPayableGlAccountId(data);
            },
            isEdit: isEdit,
            customMode: customMode
          })
        });
      }
    }
    return list.map(item => /*#__PURE__*/React.createElement(ListItem, {
      key: !isEdit ? "List_ITEM_NEW_".concat(item.id) : "List_ITEM_".concat(item.id),
      item: item
    }));
  };
  const saveProviderToProperty = async function () {
    let _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        propertyIdExt: undefined,
        providerInfoExt: undefined
      },
      propertyIdExt = _ref3.propertyIdExt,
      providerInfoExt = _ref3.providerInfoExt;
    if (existingPropertyProviders.findIndex(provider => provider.id === (providerInfoExt === null || providerInfoExt === void 0 ? void 0 : providerInfoExt.id)) !== -1) {
      return;
    }
    const providerToSave = {
      propertyId: propertyIdExt || propertyId,
      utilityProviderId: providerInfoExt === null || providerInfoExt === void 0 ? void 0 : providerInfoExt.id
    };
    await store.properties.addPropertyUtilityProviderAsync.run(providerToSave);
  };
  const createEditCustomProvider = async _ref4 => {
    let isEditProvider = _ref4.isEditProvider,
      name = _ref4.name,
      website = _ref4.website,
      providerId = _ref4.providerId,
      genericUtilityTypesToAssign = _ref4.genericUtilityTypesToAssign;
    if (isEditProvider) {
      await store.utilityProviders.editCustomUtilityProvidersAsync.run({
        name,
        website,
        providerId,
        propertyId
      });
      return providerId;
    } else {
      const _await$store$utilityP = await store.utilityProviders.addCustomUtilityProvidersV2Async.run({
          name,
          website,
          propertyId,
          utilityTypeIds: genericUtilityTypesToAssign
        }),
        createdProviderId = _await$store$utilityP.response,
        isSuccessful = _await$store$utilityP.isSuccessful;
      if (isSuccessful) {
        return createdProviderId;
      }
    }
  };
  const createCustomUtilitiesAndApplyToProvider = async _ref5 => {
    let utilityName = _ref5.utilityName,
      allocationMethodType = _ref5.allocationMethodType,
      vacantUnitUsageType = _ref5.vacantUnitUsageType,
      vacantUnitAllocationType = _ref5.vacantUnitAllocationType,
      utilityCADType = _ref5.utilityCADType,
      providerIdToAttach = _ref5.providerIdToAttach;
    return store.utilityProviders.createCustomUtilityTypeAndAttachToProviderAsync.run({
      name: utilityName,
      defaultAllocationMethod: allocationMethodType,
      defaultVacantUnitUsage: vacantUnitUsageType,
      paidBy: vacantUnitAllocationType,
      cad: utilityCADType,
      utilityProviderId: providerIdToAttach
    });
  };

  // eslint-disable-next-line
  const saveUtilityProvider = async _ref6 => {
    let handleModalClose = _ref6.handleModalClose;
    try {
      const selectedUtilitiesInternal = [...selectedUtilities];
      const buildingsResp = await store.buildings.getBuildingAsync.run({
        propertyId
      });
      let customProviderId;
      if (isCustomProviderMode) {
        if (isEditBillingTemplate) {
          await createEditCustomProvider({
            isEditProvider: isEditBillingTemplate,
            name: customProviderName,
            website: customProviderWebsite,
            providerId: selectedProviderInfo.id
          });
          for (let customUt of selectedUtilitiesInternal.filter(i => i === null || i === void 0 ? void 0 : i.id.startsWith('customUtilityId_'))) {
            const createdCustomUtilitiesResp = await createCustomUtilitiesAndApplyToProvider({
              utilityName: customUt.label,
              allocationMethodType: null,
              //  utilityAllocationMethod,
              vacantUnitUsageType: null,
              //  utilityBillFrequency,
              vacantUnitAllocationType: null,
              //  VACANT_UNIT_ALLOCATIONS.DivideAmongOccupied,
              utilityCADType: null,
              //  utilityCad,
              providerIdToAttach: selectedProviderInfo.id
            });
            if (createdCustomUtilitiesResp !== null && createdCustomUtilitiesResp !== void 0 && createdCustomUtilitiesResp.isSuccessful) {
              const matchingCustomUtId = selectedUtilitiesInternal.findIndex(i => i.id === customUt.id);
              if (matchingCustomUtId !== -1) {
                selectedUtilitiesInternal[matchingCustomUtId] = Object.assign({}, selectedUtilitiesInternal[matchingCustomUtId], createdCustomUtilitiesResp.response);
              }
            }
          }
        } else {
          customProviderId = await createEditCustomProvider({
            isEditProvider: isEditBillingTemplate,
            name: customProviderName,
            website: customProviderWebsite,
            providerId: undefined,
            genericUtilityTypesToAssign: selectedProviderUtilities.map(i => i.utilityTypeId)
          });
          for (let customUt of selectedUtilitiesInternal.filter(i => i === null || i === void 0 ? void 0 : i.id.startsWith('customUtilityId_'))) {
            const createdCustomUtilitiesResp = await createCustomUtilitiesAndApplyToProvider({
              utilityName: customUt.label,
              allocationMethodType: null,
              //  utilityAllocationMethod,
              vacantUnitUsageType: null,
              //  utilityBillFrequency,
              vacantUnitAllocationType: null,
              //  VACANT_UNIT_ALLOCATIONS.DivideAmongOccupied,
              utilityCADType: null,
              //  utilityCad,
              providerIdToAttach: customProviderId
            });
            if (createdCustomUtilitiesResp !== null && createdCustomUtilitiesResp !== void 0 && createdCustomUtilitiesResp.isSuccessful) {
              const matchingCustomUtId = selectedUtilitiesInternal.findIndex(i => i.id === customUt.id);
              if (matchingCustomUtId !== -1) {
                selectedUtilitiesInternal[matchingCustomUtId] = Object.assign({}, selectedUtilitiesInternal[matchingCustomUtId], createdCustomUtilitiesResp.response);
              }
            }
          }
        }
      }
      const buildingIds = buildingsResp.isSuccessful && buildingsResp.response.map(item => item.id);
      const newUtilityConfig = {
        utilityProviderId: selectedProviderInfo.id,
        billFrequencyType: utilityBillFrequency,
        allocationMethod: utilityAllocationMethod,
        utilityCap: 0,
        buildingIds,
        customCommonAreaDeduction: utilityCad,
        vacantUnitAllocation: VACANT_UNIT_ALLOCATIONS.DivideAmongOccupied,
        vacantUnitUsage: vacantUnitUsage,
        vacantUnitUsageLimit: vacantUnitUsage === VACANT_UNIT_USAGE.LimitedUsage ? vacantUnitUsageLimit / 100 : null,
        goodWillDeduction: 0,
        utilityTypeIds: selectedUtilitiesInternal.map(i => i.utilityTypeId),
        propertyUtilityId: propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId
      };
      if (store.company.companyFeatureStore.isAppfolio && (customGlAccountId || customPayableGlAccountId)) {
        await store.credentials.patchAppfolioPropertiesAsync.run({
          properties: [{
            propertyLivableId: propertyId,
            utilityGlAccounts: {
              value: [_objectSpread({
                propertyUtilityLivableId: propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId,
                glAccountExternalId: customGlAccountId || store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId || null
              }, store.account.featureFlagsStore.getIsGlCodesEnabled ? {
                accountsPayableGlAccountExternalId: customPayableGlAccountId
              } : {})]
            }
          }]
        });
      }
      if (isEditBillingTemplate) {
        await store.propertyUtility.updatePropertyUtilitiesAsync.run([newUtilityConfig]);
        toast('success', {
          body: ['Successfully saved!']
        });
      } else {
        await saveProviderToProperty({
          propertyIdExt: propertyId,
          providerInfoExt: isCustomProviderMode && customProviderId ? {
            id: customProviderId
          } : selectedProviderInfo
        });
        if (isCustomProviderMode) {
          const _await$store$utilityP2 = await store.utilityProviders.getUtilityProvidersAsync.run({
              utilityProviderId: customProviderId
            }),
            utilityProvider = _await$store$utilityP2.response;
          newUtilityConfig.utilityProviderId = utilityProvider.id;
        }
        await store.propertyUtility.createPropertyUtilitiesAsync.run({
          propertyId: propertyId,
          propertyUtilities: [newUtilityConfig]
        });
        toast('success', {
          body: ['Successfully added!']
        });
        // After the utility exists, never before - the credential row must reference a real
        // propertyUtilityId. A failure here is reported but does not undo the utility.
        await saveCredentialAfterUtilityExists();
      }

      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      callbackTrigger && callbackTrigger();
      handleModalClose();
    } catch (error) {
      toast('error', {
        body: ['Something went wrong', error]
      });
    }
  };
  const getIsNetworkLoading = () => {
    return store.utilityProviders.searchUtilityProvidersAsync.inProgress || store.utilityProviders.getAllUtilityTypesAsync.inProgress || store.utilityProviders.getUtilityProvidersListDataAsync.inProgress || store.utilityProviders.getUtilityInfoAsync.inProgress || store.properties.updatePropertyAsync.inProgress || store.properties.addPropertyUtilityProviderAsync.inProgress || store.utilityProviders.editCustomUtilityProvidersAsync.inProgress || store.utilityProviders.addCustomUtilityProvidersV2Async.inProgress || store.utilityProviders.createCustomUtilityTypeAndAttachToProviderAsync.inProgress || store.buildings.getBuildingAsync.inProgress || store.propertyUtility.updatePropertyUtilitiesAsync.inProgress || store.utilityProviders.getUtilityProvidersAsync.inProgress || store.propertyUtility.createPropertyUtilitiesAsync.inProgress;
  };
  useEffect(() => {
    // eslint-disable-next-line
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, !isEditBillingTemplate && !isCustomProviderMode ? t('add_new_property_flow.find_the_provider') : t('add_new_property_flow.provider')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, !isEditBillingTemplate && !isCustomProviderMode ? t('add_new_property_flow.find_a_provider_of_the_utilities_that_are_mentioned_in_your_bill') : t('add_new_property_flow.provider_description')), isCustomProviderMode ? /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "name",
    name: "name",
    label: t('add_new_property_flow.provider_name'),
    variant: "outlined",
    fullWidth: true,
    value: customProviderName,
    onChange: e => {
      setCustomProviderName(e.target.value);
    },
    error: !customProviderName && !customProviderName.length,
    helperText: !customProviderName && !customProviderName.length && getRequiredTextMessage('Provide Name')
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('add_new_property_flow.provider_website'),
    id: "website",
    name: "website",
    variant: "outlined",
    fullWidth: true,
    value: customProviderWebsite,
    onChange: e => {
      setCustomProviderWebsite(e.target.value);
    }
  })))) : /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    id: "provider-selector",
    key: "key-provider-selector",
    variant: "withIcon",
    disablePortal: true,
    loading: store.utilityProviders.searchUtilityProvidersAsync.inProgress,
    disabled: isEditBillingTemplate,
    clearIcon: true,
    popupIcon: null,
    value: (selectedProviderInfo === null || selectedProviderInfo === void 0 ? void 0 : selectedProviderInfo.name) || (selectedProviderInfo === null || selectedProviderInfo === void 0 ? void 0 : selectedProviderInfo.utilityProviderName) || '',
    options: searchResultItems,
    onInputChange: searchUtilityProviders,
    onChange: configureUtilityProvider,
    renderInput: params => /*#__PURE__*/React.createElement(InputWithIcon, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "search"
      })
    }, /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      id: "provider-selector",
      label: t('add_new_property_flow.provider_search')
    })))
  })), /*#__PURE__*/React.createElement(UtilityCredentialSlot, {
    isLivableStaff: isLivableStaff,
    isScraperSupportedProvider: isScraperSupportedProvider,
    className: classes.xlSection,
    companyId: companyId,
    propertyId: propertyId,
    propertyUtilityId: isEditBillingTemplate ? propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId : undefined,
    utilityProviderId: selectedProviderInfo === null || selectedProviderInfo === void 0 ? void 0 : selectedProviderInfo.id,
    utilityTypeId: (_singleElementOfArray2 = singleElementOfArray(selectedUtilities)) === null || _singleElementOfArray2 === void 0 ? void 0 : _singleElementOfArray2.id,
    providerName: (selectedProviderInfo === null || selectedProviderInfo === void 0 ? void 0 : selectedProviderInfo.name) || customProviderName,
    credential: utilityCredential,
    onChanged: loadCredential,
    pendingRef: pendingCredentialRef
  }), (!!selectedProviderUtilities.length || (propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$util2 = propertyUtility.utilityTypes) === null || _propertyUtility$util2 === void 0 ? void 0 : _propertyUtility$util2.length) || isCustomProviderMode) && /*#__PURE__*/React.createElement(UtilitiesAutocomplete, {
    key: 'SelectedUtilitiesAutocompleteKey',
    id: 'SelectedUtilitiesAutocompleteId',
    selectedUtilities: selectedUtilities,
    selectedProviderUtilities: selectedProviderUtilities,
    setSelectedUtilities: setSelectedUtilities,
    isCustomProviderMode: isCustomProviderMode
  }), selectedUtilities && !!selectedUtilities.length && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.billing_settings'))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GetBillingSettingsList, null))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '192-add-edit-billing-template-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    disabled: getIsNetworkLoading() || isCustomProviderMode && !customProviderName && !customProviderName.length || !selectedUtilities.length,
    onClick: async () => saveUtilityProvider({
      handleModalClose
    }),
    'custom-attribute': '193-add-edit-billing-template-modal'
  }, isEditBillingTemplate ? t('add_new_property_flow.save_and_close') : t('add_new_property_flow.add_bill_template')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: getIsNetworkLoading()
  }));
});